import React from "react";
import { Box, Label, Show } from "Components";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetailViewModel";
import { StudentRota } from "../WeeklyRotaDetailModel";
import { ListItemBox, ListItem, AttendanceStatusLabel, IncidentLabel, SessionStatusColourLabel, MentorNameLabel } from "./StudentRotaDetailView.styles";

interface SessionDetailsListViewProps {
    rota: StudentRota;
    viewModel: WeeklyRotaDetailsViewModel;
}

export const SessionDetailsListView: React.FC<SessionDetailsListViewProps> = ({ rota, viewModel }) => (
    <Box>
        <ListItemBox>
            <SessionCoreDetails rota={rota} viewModel={viewModel} />
            <Show if={viewModel.isOverdueSession}>
                <ListItem className="fullGrid">
                    <Label fontStyle="h3">Transport NOT required</Label>
                </ListItem>
            </Show>
            <Show if={viewModel.showTransportDetails}>
                <TransportDetails rota={rota} />
            </Show>
        </ListItemBox>
    </Box>
);

interface SessionCoreDetailsProps {
    rota: StudentRota;
    viewModel: WeeklyRotaDetailsViewModel;
}

const SessionCoreDetails: React.FC<SessionCoreDetailsProps> = ({ rota, viewModel }) => (
    <>
        <ListItem>
            <Label fontStyle="h3">Session date:</Label>
            <Label>{viewModel.sessionDateDisplay}</Label>
        </ListItem>
        <ListItem>
            <Label fontStyle="h3">Session time:</Label>
            <Label>{viewModel.sessionTimeDisplay}</Label>
        </ListItem>
        <ListItem>
            <Label fontStyle="h3">Attendance:</Label>
            <AttendanceStatusLabel fontStyle="h4" $attended={rota.didAttend}>
                {viewModel.studentRotaAttendanceText}
            </AttendanceStatusLabel>
            <IncidentLabel fontStyle="h6">{viewModel.incidentText}</IncidentLabel>
        </ListItem>
        <ListItem>
            <Label fontStyle="h3">Session report status:</Label>
            <SessionStatusColourLabel fontStyle="h4" $color={viewModel.sessionStatusColour}>
                {rota.sessionStatusName}
            </SessionStatusColourLabel>
        </ListItem>
        <ListItem className="fullGrid">
            <Label fontStyle="h3">Session with mentor:</Label>
            <MentorNameLabel fontStyle="field">{rota.mentorName}</MentorNameLabel>
        </ListItem>
    </>
);

interface TransportDetailsProps {
    rota: StudentRota;
}

const TransportDetails: React.FC<TransportDetailsProps> = ({ rota }) => (
    <>
        <ListItem>
            <Label fontStyle="h3">Pickup location:</Label>
            <Label>{rota.pickupAddressTitle}</Label>
            <Label>{rota.pickupAddressLine1},</Label>
            <Label>{rota.pickupAddressLine2},</Label>
            <Label>{rota.pickupCity},</Label>
            <Label>{rota.pickupPostcode}</Label>
        </ListItem>
        <ListItem>
            <Label fontStyle="h3">Drop off location:</Label>
            <Label>{rota.dropAddAddressTitle}</Label>
            <Label>{rota.dropAddAddressLine1},</Label>
            <Label>{rota.dropAddAddressLine2},</Label>
            <Label>{rota.dropAddCity},</Label>
            <Label>{rota.dropAddPostcode}</Label>
        </ListItem>
    </>
);
